import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import Vue from 'vue'
import Router from 'vue-router'
import to_boolean from 'nllib/src/convert/to_boolean'

import global_query_processor from '@/router/init_router/global_query_processor';

global_query_processor.init();

Vue.use(Router);

// console.log(JSON.stringify(process.env, null, 4));

const get_options = function () {
    const VUE_APP_vue_router_history_enable = to_boolean(process.env.VUE_APP_vue_router_history_enable, false);
    const o = {
        routes: [],
    };
    if (VUE_APP_vue_router_history_enable) {
        o.mode = `history`;
        o.base = process.env.BASE_URL;
    }
    return o;
};
const options = get_options();

const aRouter = new Router(options);

aRouter.beforeEach((to, from, next) => {
    // to: Route 即将要进入的目标路由对象
    // from: Route 当前导航正要离开的路由对象
    // next: Function 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    console.log('守卫打印：');
    console.log(to);
    console.log(from);
    let pswValidStatus = localStorage.getItem('pswValidStatus');
    // 如果是刚从别的地方跳过来，先获取pswValidStatus
    if (to.name === 'redirect') {
        pswValidStatus = to.query.pswValidStatus || '0';
        localStorage.setItem('pswValidStatus', pswValidStatus);
    }
    if (to.name !== 'root' && to.name !== 'login' && to.name !== 'redirect' && to.name !== 'admin-change-password' && pswValidStatus === '1') {
        next('/admin/change-password');
        return
    }
    next();
});

export default aRouter;

